import React from "react";
import { Label, Input, Select } from "@/components/form";
import { YearField } from "./";

export interface FacilityDetailsProps {
  values: {
    squareFeet: string;
    maxCapacity: string;
    yearEstablished: string;
    hasParking: string;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onSelectChange?: (value: string, id: string) => void;
  errors?: {
    squareFeet?: string;
    maxCapacity?: string;
    yearEstablished?: string;
    hasParking?: string;
  };
  className?: string;
}

const FacilityDetailsFieldSet: React.FC<FacilityDetailsProps> = ({
  values,
  onChange,
  onSelectChange,
  errors = {},
  className = "",
}) => {
  const handleParkingChange = (value: string) => {
    if (onSelectChange) {
      onSelectChange(value, "hasParking");
    }
  };

  // Parking options
  const parkingOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "limited", label: "Limited" }
  ];

  return (
    <div className={`grid grid-cols-1 gap-6 md:grid-cols-2 ${className}`}>
      <div>
        <Label htmlFor="squareFeet">Square Footage</Label>
        <Input
          id="squareFeet"
          name="squareFeet"
          type="text"
          placeholder="Enter facility size in sq ft"
          value={values.squareFeet}
          onChange={onChange}
          error={!!errors.squareFeet}
          hint={errors.squareFeet || "Total square footage of the gym facility"}
          inputMode="numeric"
        />
      </div>

      <div>
        <Label htmlFor="maxCapacity">Maximum Capacity</Label>
        <Input
          id="maxCapacity"
          name="maxCapacity"
          type="text"
          placeholder="Maximum number of people"
          value={values.maxCapacity}
          onChange={onChange}
          error={!!errors.maxCapacity}
          hint={errors.maxCapacity || "Maximum number of people allowed in the facility"}
          inputMode="numeric"
        />
      </div>

      <YearField
        id="yearEstablished"
        name="yearEstablished"
        value={values.yearEstablished}
        onChange={onChange}
        error={!!errors.yearEstablished || errors.yearEstablished}
        hint="The year this facility was established"
        minYear={1950}
        maxYear={new Date().getFullYear()}
      />

      <div>
        <Label id="hasParking-label" htmlFor="hasParking">Parking Available</Label>
        <Select
          options={parkingOptions}
          id="hasParking"
          ariaLabelledBy="hasParking-label"
          name="hasParking"
          value={values.hasParking}
          onChange={handleParkingChange}
          error={!!errors.hasParking}
          hint={errors.hasParking}
        />
      </div>
    </div>
  );
};

export default FacilityDetailsFieldSet; 